import { cn } from '~/shared/lib/cn';

type Properties = React.HTMLAttributes<HTMLDivElement>;

export function Logotype({ className, ...properties }: Properties) {
  return (
    <div className={cn('flex flex-col', { className })} {...properties}>
      <div className="text-base font-bold leading-none sm:text-[1.75rem]">
        <span className="text-primary">Course</span>
        <span className="text-accent-foreground">Garden</span>
      </div>
      <div className="whitespace-nowrap text-base text-muted-foreground sm:text-lg">
        mini-courses AI Creator
      </div>
    </div>
  );
}
